const renderOneLabel = ({ direction, translate, ...rest }) => {
  const {
    originLabelKey = 'cmp-preposition--origin-place',
    destinationLabelKey = 'cmp-preposition--destination-place',
    separatorKey = 'minus',
    separatorStyles,
    showOriginCityName = true,
    showOriginAirportCode = false,
    showDestinationCityName = true,
    showDestinationAirportCode = false,
    showOriginLabel = false,
    showDestinationLabel = false,
    showSeparator = true,
    originCity = '',
    origin = '',
    destination = '',
    destinationCity = ''
  } = rest;

  const labels = [];
  if (showOriginLabel) {
    labels.push(translate(originLabelKey, 'From'));
  }
  if (showOriginCityName) {
    labels.push(originCity);
  }
  if (showOriginAirportCode) {
    labels.push(`(${origin})`);
  }
  if (showSeparator) {
    labels.push(translate(`cmp-separator-${separatorStyles?.content}`, separatorKey));
  }
  if (showDestinationLabel) {
    labels.push(translate(destinationLabelKey, 'To'));
  }
  if (showDestinationCityName) {
    labels.push(destinationCity);
  }
  if (showDestinationAirportCode) {
    labels.push(`(${destination})`);
  }

  if (direction === 'rtl') {
    // This fix the issue for join arabic characters.
    // Insert Unicode direction marks: \u200E --> LTR or \u200F --> RTL
    // In this case use LTR mark because we revert the text by code and join it from left to right
    return labels.reverse().join('\u200E ');
  }
  return labels.join(' ');
};

export { renderOneLabel };
